import * as React from 'react';

import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from "@material-ui/icons/ChevronRight";


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';

import Rest from "../../../services/Rest";

import "./TablePermission.scss";

// tslint:disable-next-line:no-empty-interface
export interface ITablePermissionPros {
    dataToFilter: {
        profile_id: number,
        publisher_id: number,
        publisher_name: string,
        store_id: number,
        store_name: string,
        user_id: number,
        user_name: string
    },
    receivePermissionToDetail(permission: any): void
}

export interface ITablePermission {
    count: number,
    limit: number,
    offset: number,
    openDeleteConfirmationDialig: boolean,
    page: number,
    permission: {
        profile_id: number,
        publisher_id: number,
        publisher_name: string,
        store_id: number,
        store_name: string,
        user_id: number,
        user_name: string
    },
    rows?: any,
    rowToDelete: any
}

const QUERY_SEARCH_PERMISSION = gql`
    query findPermissions($customFilter: PermissionRegisteredFilter) {
        findPermissions(permissionRegisteredFilter: $customFilter) {
            profile_id,
            profile_name,
            publisher_id,
            publisher_name,
            store_id,
            store_name,
            user_id,
            user_name 
        }
    }
`;

const QUERY_DELETE_PERMISSION = ` 
    query deletePermission($customFilter:  PermissionRegisteredFilter) { 
        deletePermission(permissionRegisteredFilter: $customFilter) {
            profile_id,
            profile_name,
            publisher_id,
            publisher_name,
            store_id,
            store_name,
            user_id,
            user_name 
        }
    } `;


export class TablePermission
  extends React.Component<ITablePermissionPros, ITablePermission> {

    constructor(props: ITablePermissionPros) {
        super(props);
    
        this.state = {
            count: 10,
            limit: 10,
            offset: 0,
            openDeleteConfirmationDialig: false,
            page: 0,
            permission: {
                profile_id: this.props.dataToFilter.profile_id,
                publisher_id: this.props.dataToFilter.publisher_id,
                publisher_name: this.props.dataToFilter.publisher_name,
                store_id: this.props.dataToFilter.store_id,
                store_name: this.props.dataToFilter.store_name,
                user_id: this.props.dataToFilter.user_id,
                user_name: this.props.dataToFilter.user_name
            },
            rowToDelete: {},
            rows: []
            
        }

        this.handleChangePage = this.handleChangePage.bind(this);
    }

    public changeState = (permission:any) => {
        this.setState( {permission} );
    }

    public render() {

        const filter = {
            "customFilter": {
                "profile_id": this.state.permission.profile_id,
                "publisher_id": this.state.permission.publisher_id,
                "publisher_name": this.state.permission.publisher_name,
                "store_id": this.state.permission.store_id,
                "store_name": this.state.permission.store_name,
                "user_id": this.state.permission.user_id,
                "user_name":this.state.permission.user_name
            }
        };

        return (
            <Query query={QUERY_SEARCH_PERMISSION} variables={filter} partialRefetch={true} fetchPolicy="no-cache" >
                {({ loading, error, data}) => {

                    return (
                        <div>

                            <Dialog
                                open={this.state.openDeleteConfirmationDialig}
                                onClose={this.handleCloseDeleteConfirmationDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Confirma a exclusão do item?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Após a exclusão de um item a operação não pode mais ser desfeita.
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleCloseDeleteConfirmationDialog} color="primary">
                                        Cancelar
                                    </Button>
                                    <Button onClick={this.handleConfirmDeleteConfirmationDialog} color="primary" autoFocus={true}>
                                        Confirmar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        
                            {
                                loading ?  <LinearProgress /> : 
                                <div>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Ordem</TableCell>
                                                <TableCell>Usuário</TableCell>
                                                <TableCell>Perfil</TableCell>
                                                <TableCell>Ação</TableCell>
                                            </TableRow>
                                        </TableHead>
                        
                                        {this.getTableBody(error, data)}
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        page={this.state.page}
                                        count={data && data.findPermissions ? data.findPermissions.length : this.state.count}
                                        rowsPerPage={this.state.limit}
                                        rowsPerPageOptions={[]}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={undefined}
                                    />
                                </div>
                            }
                        </div>
                    );
                }}
            </Query>
            
        );
    }

    public getTableBody (error: any, data:any) {
         
        if(!error && data && data.findPermissions) {

            return (
                <TableBody>
                    {
                        this.paginacaoVirtual(data.findPermissions).map((row: any, key: number) => {
                        return (
                            <TableRow key={key}>
                                <TableCell className="padding-left">{ 1 + key + (this.state.page * this.state.limit) }</TableCell>
                                <TableCell component="th" scope="row">{row.user_name}</TableCell>
                                <TableCell>{row.profile_name}</TableCell>
                                <TableCell className="actionColumn">
                                    <IconButton className="expandAction"  onClick={this.handleGetPermissionDetail.bind(this, row)} aria-label="Deletar">
                                        <ChevronRightIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        );
                        })
                    }
                </TableBody>
            );
        } else {
            return null;
        }
    }

    private handleGetPermissionDetail = (row : any) => {
        this.props.receivePermissionToDetail(row);
    }

    private deleteItem (row : any) {

        const filter = {
            "customFilter": {
                "profile_id": row.profile_id,
                "publisher_id": row.publisher_id,
                "store_id": row.store_id,
                "user_id": row.user_id
            }
        };

        const body = {
            "operationName":"",
            "query":QUERY_DELETE_PERMISSION,
            "variables": filter
        };
        
        Rest.GraphqlPOST(body)
            .then( data  => {
                this.forceUpdate();
            });
    }
    
    private handleCloseDeleteConfirmationDialog = () => {
        this.setState({ openDeleteConfirmationDialig: false, rowToDelete: {} });
    };

    private handleConfirmDeleteConfirmationDialog = () => {
        this.deleteItem(this.state.rowToDelete);
        this.setState({ openDeleteConfirmationDialig: false, rowToDelete: {} });
    };

    /**
     * Pagination
     * 
     * Methods add pagination to the result table
     * 
     */
    private paginacaoVirtual = (permissions: any[]) => {
        const start = this.state.offset;
        const end = start + 10;
        return permissions.slice(start, end)
    }

    private handleChangePage(ev: any, pageParam: number) {

        if (pageParam <= this.state.page) {
            this.setState({
                offset: pageParam * 10 <= 0 ? 0 : pageParam * 10,
                page: pageParam,
            });
        } else {
            this.setState({
                offset: pageParam * 10,
                page: pageParam,
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/permissions/TablePermission.tsx